import React from 'react';
import './Contact.css';


const Contact = (props) => (
  <div className="contact_container">
    <div className="contacts">
      <h2>Contact</h2>
      <p>Feel free to reach out to me with any questions, comments, or suggestions.</p>
      <div className="contact_box methods">
        <i className="fa fa-user"> Brad McAllister</i><br />
        <a href="https://twitter.com/bmcallister" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"> @bmcallister</i></a><br />
        <a href="mailto:bdm@bdmenterprises.com"><i className="fa fa-envelope"> bdm@bdmenterprises.com</i></a>
      </div>
    </div>
  </div>
);

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js